module.exports = __webpack_public_path__ + "img/AQ.91e47268.svg";